"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var AdobeEvent_1 = require("./AdobeEvent");
var PageLoadDataService_1 = require("./services/PageLoadDataService");
var WindowService_1 = require("./services/WindowService");
var FasVapAdobeLaunch = (function () {
    function FasVapAdobeLaunch() {
    }
    FasVapAdobeLaunch.prototype.trackPageLoadEvent = function (data) {
        var title = data.title;
        var pageData = PageLoadDataService_1.default.buildPageData(data);
        pageData = title ? __assign(__assign({}, pageData), { pageTitle: title }) : pageData;
        this.trackEvent('pageLoaded', 'page', pageData);
    };
    FasVapAdobeLaunch.prototype.trackPageLoadCompleted = function () {
        this.trackEvent('pageLoadCompleted');
    };
    FasVapAdobeLaunch.prototype.trackEvent = function (eventName, eventDataName, eventData) {
        var adobeEvent = new AdobeEvent_1.default(eventName, eventDataName, eventData);
        WindowService_1.default.pushToDatalayer(adobeEvent.getData());
    };
    FasVapAdobeLaunch.prototype.trackUserDetected = function (eventData) {
        this.trackEvent('userDetected', 'user', eventData);
    };
    FasVapAdobeLaunch.prototype.trackUserSignedIn = function () {
        this.trackEvent('userSignedIn');
    };
    FasVapAdobeLaunch.prototype.trackToolUsed = function (eventData) {
        this.trackEvent('toolUsed', 'tool', eventData);
    };
    FasVapAdobeLaunch.prototype.initializePage = function (data) {
        this.trackPageLoadEvent(data.page);
        this.trackUserDetected(data.user);
        if (data.userSignedIn) {
            this.trackUserSignedIn();
        }
        if (data.toolUsed) {
            this.trackToolUsed(data.toolUsed);
        }
        this.trackPageLoadCompleted();
    };
    FasVapAdobeLaunch.prototype.getPageName = function (data) {
        return PageLoadDataService_1.default.buildPageName(data);
    };
    return FasVapAdobeLaunch;
}());
exports.default = FasVapAdobeLaunch;
//# sourceMappingURL=FasVapAdobeLaunch.js.map